export const useStore = defineStore('main', () => {
  const rev = ref()
  const load = ref()
  const currency = ref()
  const currencyIsoCode = ref()
  const mainMenu = ref()
  const footerMenu = ref()
  const shopInformation = ref()
  const modal = ref<any>({ type: false, name: null })
  const filterLoading = ref()
  const searchBarIsFocused = ref(false)
  const tel = computed(() => `tel:+48${shopInformation.value.shopInformation.phone.replaceAll(' ', '')}`)
  const init = async () => {
    const [currencyData, mainMenuData, footerMenuData, shopInformationData] = await Promise.all([
      $fetch('/store-api/currency', {
        method: 'POST'
      }),
      $fetch('/store-api/navigation/main-navigation/main-navigation', {
        method: 'POST',
        body: {
          filter: [
            {
              type: 'not',
              queries: [
                {
                  field: 'category.customFields.category_isBaseCategory',
                  type: 'equals',
                  value: 'true'
                }
              ]
            }
          ],
          includes: {
            category: ['id', 'name', 'externalLink', 'children', 'categoryUrlData']
          }
        }
      }),
      $fetch('/store-api/navigation/footer-navigation/footer-navigation', {
        method: 'POST',
        body: {
          includes: {
            category: ['id', 'name', 'externalLink', 'children', 'categoryUrlData']
          }
        }
      }),
      $fetch('/store-api/shop-information')
    ])
    currency.value = currencyData.filter((i: any) => i.isSystemDefault)[0].symbol
    currencyIsoCode.value = currencyData.filter((i: any) => i.isSystemDefault)[0].isoCode
    mainMenu.value = mainMenuData
    footerMenu.value = footerMenuData
    shopInformation.value = shopInformationData
  }
  const getModal = (modalData: any, nameData: any) => {
    modal.value = {
      type: modalData,
      name: nameData
    }
  }

  return { rev, load, currency, currencyIsoCode, mainMenu, footerMenu, shopInformation, modal, filterLoading, searchBarIsFocused, tel, init, getModal }
})
